import HeaderMenusRows from "./HeaderMenusRows";
import {setDrawerSearch} from "../../../reducer/actions";
import HeaderNav from "../components/HeaderNav";
import Drawer from "../../Drawer";
import Header from "../Header";
import MallName from "./MallName";
import cookies from "../../../utils/cookies";
import {getI18n} from "react-i18next";

function HeaderMallWrap(props) {
  let {
    type,
    absolute,
    style,
    nav,
    navs,
    menus,
    navHandle,
    drawerNavVisible,
    setDrawerNavVisible,
    drawerMyVisible,
    setDrawerMyVisible,
    logout,
    dispatch,
    navigateTo,
    t,
    floatHeader,
    agentInfo,
    customFloatHeader
  } = props;
  const lang = getI18n().language;
  
  if (customFloatHeader){
    floatHeader = customFloatHeader;
  }
  return (
    <>
      {
        type && type === 'home' || type === 'bookinglist'
          ? <div className={`${absolute ? 'absolute' : 'relative'} ${floatHeader ? 'bg-white' : ''} w-[100%] mdmax:mx-auto mdmax:fixed mdmax:bg-white mdmax:w-[100%] mdmax:px-[3%] mdmax:z-[99] z-[22]`}
                 style={style}>
            <div className="flex flex-1 py-[24px] mdmax:py-[18px] items-center container-center justify-between">
              <div className="flex flex-1 md:hidden">
                <i onClick={() => setDrawerNavVisible(true)}
                   className={'iconfont icon-more text-3xl hidden mdmax:block'}></i>
              </div>
              <div className="flex flex-1 items-center justify-center">
                
                {
                  agentInfo.smallLogoView
                    ? <img src={agentInfo.smallLogoView} className="h-[80px] mdmax:h-[30px] "/>
                    : <MallName className={`font-bold text-shadow-normal mdmax:text-center text-white w-[200px]
              text-4xl mdmax:text-2xl mdmax:text-black ${floatHeader ? 'text-black' : 'md:text-white '}`}/>
                }
                
                <HeaderNav type={type}
                           navs={navs}
                           navStyle={{ color: floatHeader ? '#333' : '#fff' }}
                           style={{
                             paddingBottom: 0, padding: '0 5px', margin: 0
                           }}/>
              </div>
              <HeaderMenusRows nav={nav}
                               menus={menus}
                               navHandle={navHandle}
                               iconStyle={{ color: floatHeader ? '#333' : '#fff' }}
                               style={{ flex: 'none' }}/>
              
              <div className={'flex-1 hidden mdmax:block text-right'}>
                {
                  agentInfo.isProduct !== '0'
                    ? <i onClick={() => dispatch(setDrawerSearch(true))} className={'iconfont icon-search text-3xl'}></i>
                    : null
                }
                <i onClick={() => navigateTo('/messageCenter')}
                   className={'iconfont icon-notice text-3xl ml-[1.4rem]'}/>
              </div>
            </div>
            
            <Drawer visible={drawerNavVisible}
                    width={'65%'}
                    offsetTop={65}
                    theme="dark"
                    onToggle={setDrawerNavVisible}
                    className={'md:hidden'}
                    wrapClassName={'pr-0'}
                    left>
              <div className={''}>
                <div>
                  <i onClick={() => setDrawerNavVisible(false)}
                     className="iconfont icon-delete text-[18px] text-white"></i>
                </div>
                {
                  navs.map((nav, i) => (
                    <a className="w-[100%] block py-[20px] text-[17px] mdmax:text-[14px] border-b-[1px] text-white"
                       onClick={() => navigateTo(nav.path)}
                       key={i}>
                      {lang === 'en' ? nav.nameEN : nav.name}
                    </a>
                  ))
                }
                <a onClick={logout}
                   className="w-[100%] block py-[20px] text-[17px] mdmax:text-[14px] border-b-[1px] text-white">
                  {t('退出')}
                </a>
              </div>
            </Drawer>
          
          </div>
          : <div className={`${absolute ? 'absolute' : 'relative'} ` +
          "bg-white w-[100%] mdmax:w-[94%] mdmax:mx-auto mdmax:fixed " +
          "mdmax:bg-white mdmax:w-[100%] mdmax:px-[3%] mdmax:z-[99] mdmax:hidden"}
                 style={style}>
            <div className="flex flex-1 py-[24px] mdmax:py-[18px] items-center container-center justify-between">
              <div className="flex flex-1 md:hidden">
                <i onClick={() => setDrawerNavVisible(true)}
                   className="iconfont icon-more text-3xl hidden mdmax:block"></i>
              </div>
              <div className="flex flex-1 items-center justify-center">
                {
                  agentInfo.smallLogoView
                    ? <img src={agentInfo.smallLogoView} className="h-[80px] mdmax:h-[30px]"/>
                    : <MallName className={`font-bold text-shadow-normal mdmax:text-center text-white w-[200px]
              text-4xl mdmax:text-2xl mdmax:text-black ${floatHeader ? 'text-black' : 'md:text-white '}`}/>
                }
                <HeaderNav type={type}
                           navs={navs}
                           style={{
                             paddingBottom: 0, padding: '0 5px', margin: 0
                           }}/>
              </div>
              <HeaderMenusRows nav={nav}
                               menus={menus}
                               navHandle={(name) => navHandle(name, 'showCartMenu')}
                               style={{ flex: 'none' }}
                               theme="black"/>
              
              <div className="flex-1 hidden mdmax:block text-right">
                <i className="iconfont icon-search text-3xl"></i>
                <i className="iconfont icon-notice text-3xl ml-[1.4rem]"></i>
              </div>
            </div>
          </div>
      }
      <Drawer visible={drawerMyVisible}
              wrapClassName="p-0"
              onToggle={setDrawerMyVisible}>
        <div className="p-[80px] pb-[20px] border-b border-[#ddd]">
          <i className="iconfont icon-delete text-[26px] cursor-pointer"
             onClick={() => setDrawerMyVisible(false)}></i>
          <span className="text-[26px] ml-[15px]">{t('我的')}</span>
        </div>
        <div className="px-[80px] flex flex-col pt-[24px]">
          {
            menus.map((menu, i) => (
              <a key={i}
                 onClick={() => navigateTo(menu.path)}
                 className="text-[16px] py-[28px] flex justify-between cursor-pointer">
                <span>{t(menu.name)}</span>
                <i className="iconfont icon-right"></i>
              </a>
            ))
          }
          <a onClick={logout}
             className="text-[16px] py-[28px] flex justify-between cursor-pointer">
            <span>{t('退出')}</span>
          </a>
        </div>
      </Drawer>
    </>
  );
}

export default function HeaderMall9(topProps) {
  
  return (
    <Header loginOpenType="page" {...topProps}>
      {
        (props) => {
          let _props = { ...topProps, ...props };
          return (
            <HeaderMallWrap {..._props}/>
          );
        }
      }
    </Header>
  );
}
